module.exports = __webpack_public_path__ + "public/img/xxw_logo.c7e8b169.png";